// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAQ-X_wmq225S6paoxgnDpTaPAu2B3c5Uo",
  authDomain: "bundchen-arq-4ixvyl.firebaseapp.com",
  projectId: "bundchen-arq-4ixvyl",
  storageBucket: "bundchen-arq-4ixvyl.firebasestorage.app",
  messagingSenderId: "472548034053",
  appId: "1:472548034053:web:2305a6c10806a0b22b7e6c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);